import { render, staticRenderFns } from "./Sub-materi.vue?vue&type=template&id=743e6f12&"
import script from "./Sub-materi.vue?vue&type=script&lang=js&"
export * from "./Sub-materi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports